export default "__VITE_ASSET__Dw6J9brU__"